import { SxProps, Theme } from '@mui/material';

export const styles: Record<'container', SxProps<Theme>> = {
  container: (theme) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.gray[700],
    borderRadius: '16%',
    color: theme.palette.gray[50],
    display: 'flex',
    justifyContent: 'center',
  }),
};
